import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { EFileExtension, EFileType } from '~/shared/types';
import { useStyles } from '~/views/molecules/file-image/styles';
import { Box, Typography } from '@mui/material';
export const FileImage = ({ clickImageHandler, item, imageIndex, clickDocumentHandler }) => {
    const classes = useStyles();
    const getDocIcon = useCallback((extension) => {
        switch (extension) {
            case EFileExtension.doc:
            case EFileExtension.docx:
                return _jsx(Typography, { className: classes.docxIcon });
            case EFileExtension.ppt:
            case EFileExtension.pptx:
                return _jsx(Typography, { className: classes.pptIcon });
            case EFileExtension.xls:
            case EFileExtension.xlsx:
                return _jsx(Typography, { className: classes.xlsIcon });
            default:
                return _jsx(Typography, { className: classes.pdfIcon });
        }
    }, [classes.docxIcon, classes.pdfIcon, classes.xlsIcon, classes.pptIcon]);
    const getItemImage = useCallback((item, index) => {
        switch (item.fileType) {
            case EFileType.image:
            case EFileType.video:
                return (_jsx("img", { src: `${item.img}?w=56&h=56&fit=crop`, srcSet: `${item.img}?w=56&h=56&fit=crop`, alt: item.title, loading: index > 15 ? 'lazy' : undefined, style: { maxHeight: '100%', maxWidth: '100%' }, onClick: () => item && clickImageHandler && clickImageHandler(item, index) }));
            case EFileType.doc:
                return (_jsx(Box, { onClick: () => clickDocumentHandler && clickDocumentHandler(item, index), children: getDocIcon(item.extension) }));
            default:
                return _jsx(Typography, { className: classes.archiveIcon });
        }
    }, [classes.archiveIcon, clickImageHandler, getDocIcon, clickDocumentHandler]);
    return getItemImage(item, imageIndex || 0);
};
